module.exports = __webpack_public_path__ + "img/mockup-portrait.e536595a.png";